/** @jsx jsx */

import { Colors } from '@zapier/theme';
import { jsx } from '@emotion/core';
import { Button, Icon, Text, TruncatedText } from '@zapier/common-components';

import Link from 'app/common/components/Link';
import Tag from 'app/common/components/Tag';

const planDetailsCss = {
  marginTop: '0.8rem',
  display: 'flex',
  alignItems: 'center',
  alignContent: 'space-between',
  flexWrap: 'wrap',
};

const planNameCss = {
  marginRight: '0.5rem',
};

const subscriptionLinkCss = {
  margin: '2px',
};

const bulletCss = {
  marginRight: '8px',
};

const ctaButtonWrapperCss = {
  marginTop: '10px',
};

const planDetailsWrapperCss = {
  background: '#fff',
  fontSize: '1.3rem',
  '> *': {
    margin: 10,
  },
};

const trialDetailsCss = {
  background: Colors.iceman,
  padding: 10,
  margin: 0,
};

const featureListCss = {
  margin: '10px 0',

  li: {
    alignItems: 'center',
    display: 'flex',
    listStyle: 'none',
    marginLeft: '10px',
  },
};

const Bullet = () => (
  <Icon color={Colors.captainAmerica} css={bulletCss} name="disc" size={5} />
);

const AccountDetails = ({
  email,
  href,
  label,
  onChoose,
  onUpgradeClick,
  planName,
  showTrialInfo,
  trialDaysLeft,
}) => {
  const emailNode = !email ? null : (
    <TruncatedText block={true}>{email}</TruncatedText>
  );
  const detailsNode = showTrialInfo ? (
    <div css={trialDetailsCss}>
      <Text type="body-strong">
        Welcome to your Professional trial! These features will expire in{' '}
        {trialDaysLeft} days:
      </Text>

      <Text type="fine">
        <ul css={featureListCss}>
          <li>
            <Bullet />
            Zaps with 3 or more steps
          </li>
          <li>
            <Bullet />
            Access to our 50+ Premium Apps
          </li>
          <li>
            <Bullet />
            Advanced filtering and logic
          </li>
        </ul>
      </Text>

      <Text type="fine">
        ...and{' '}
        <Link href="/app/billing/plans" onClick={onChoose}>
          much more
        </Link>
      </Text>

      <div css={ctaButtonWrapperCss}>
        <Button
          color="primary"
          isFullWidth={true}
          isSlim={true}
          onClick={() => {
            onUpgradeClick();
            onChoose();
          }}
        >
          Upgrade Now
        </Button>
      </div>
    </div>
  ) : (
    <div css={planDetailsCss}>
      <Tag css={planNameCss}>{planName !== '' ? `${planName} Plan` : ''}</Tag>{' '}
      <Link css={subscriptionLinkCss} href={href} onClick={onChoose}>
        {label}
      </Link>
    </div>
  );

  return (
    <div css={planDetailsWrapperCss}>
      {emailNode}
      {detailsNode}
    </div>
  );
};

export default AccountDetails;
